/**
 * Camada 1 · o hook que mantem o numero do sino vivo.
 *
 * MORA AQUI e nao em cada app pelo mesmo motivo do transporte: escrito duas vezes, um dos
 * dois esqueceria de limpar o intervalo, e a tela ficaria pedindo o numero para sempre
 * depois de a pessoa sair dela.
 *
 * ELE NAO DESENHA NADA. Devolve o `EstadoSino` que o componente `Sino` ja sabe desenhar,
 * inclusive o caso de fonte fora do ar, que tem marca propria e nao vira zero.
 */

import { useEffect, useState } from 'react';
import type { EstadoSino } from './index.js';
import { lerSino, type CredenciaisChat, type LadoDaConversa } from './transporte-http.js';

/**
 * De quanto em quanto tempo reler, em milissegundos.
 *
 * 2 SEGUNDOS, POR PEDIDO DELE EM 03/09/2026: *"TEM QUE SER ATUALIZADO A CADA 2 SEGUNDOS
 * PARA QUE SEJAM EXIBIDAS EM TODOS OS APPS"*.
 *
 * O QUE COMPROU A MUDANCA: o valor anterior era 60 segundos, com a justificativa de que
 * mensagem de suporte nao e conversa ao vivo. A medicao na tela desmentiu isso: ele
 * enviou mensagem pelo app, olhou o sino do admin, e o numero nao mudou. Um minuto de
 * espera diante de um sino que nao acusa nada e indistinguivel de sino quebrado, e foi
 * exatamente essa a leitura dele.
 *
 * O CUSTO E CONHECIDO E ACEITO: a rota `/conversas/nao-lidas` passa a ser chamada 30 vezes
 * mais. Ela devolve uma CONTAGEM, e nao a lista, e o indice `mensagens_nao_lidas_idx` da
 * migration cobre exatamente esse filtro. Se a carga aparecer em producao, o caminho e
 * empurrar por evento (SSE ou realtime), e nao voltar a alongar o intervalo: alongar
 * devolve o defeito que ele acabou de apontar.
 */
const INTERVALO_MS = 2_000;

export function usarSino(
  base: string | undefined,
  lado: LadoDaConversa,
  credenciais?: CredenciaisChat,
): EstadoSino {
  // Nasce INDISPONIVEL e nao zero, e essa e a decisao inteira: antes da primeira leitura a
  // tela nao sabe quantas ha, e desenhar zero seria afirmar que nao ha nenhuma.
  const [estado, definirEstado] = useState<EstadoSino>({
    naoLidos: 0,
    medidoEm: null,
    indisponivel: true,
  });

  useEffect(() => {
    let vivo = true;

    async function medir() {
      const novo = await lerSino(base, lado, credenciais);
      // A guarda impede escrever estado depois de a tela sair, que o React acusa e que
      // esconde vazamento de intervalo atras de um aviso de console.
      if (vivo) definirEstado(novo);
    }

    void medir();
    const relogio = setInterval(() => void medir(), INTERVALO_MS);

    return () => {
      vivo = false;
      clearInterval(relogio);
    };
  }, [base, lado, credenciais]);

  return estado;
}
